import { IndustryPageTemplate } from "@/components/templates/IndustryPageTemplate";
import { aiAgentsCluster, getRelatedMoneyPages, getRelatedInsightPages } from "@/data/contentClusters";

const pageData = aiAgentsCluster.industryPages.find(p => p.slug === "ai-agents-b2b")!;
const relatedMoney = getRelatedMoneyPages("ai-agents").map(p => ({ title: p.title, slug: p.slug, pillarSlug: p.pillarSlug }));
const relatedInsights = getRelatedInsightPages("ai-agents").map(p => ({ title: p.title, slug: p.slug }));

export default function AIAgentsB2BPage() {
  return (
    <IndustryPageTemplate
      page={pageData}
      relatedMoneyPages={relatedMoney}
      relatedInsightPages={relatedInsights}
    />
  );
}
